export const BUILT_IN_COMMANDS = {
  // BASIC VISIBILITY ─────────
  show: {
    type: "command",
    allowProps: false,
  },
  hide: {
    type: "command",
    allowProps: false,
  },
  disconnect: {
    type: "command",
    allowProps: false,
  },

  // TEXT & STYLE ─────────
  text: {
    type: "command",
    allowProps: true,
    validProps: {
      value: { type: "string" },
      size: { type: "number" },
      weight: { type: "number" },
      lineHeight: { type: "number" },
      letterSpacing: { type: "number" },
      color: { type: "string" },
      align: { type: "string" },
      verticalAlign: { type: "string" },
    },
  },
  background: {
    type: "command",
    allowProps: true,
    validProps: { color: { type: "string" } },
  },
  opacity: {
    type: "command",
    allowProps: true,
    validProps: { value: { type: "number" } },
  },
  shadow: {
    type: "command",
    allowProps: true,
    validProps: {
      color: { type: "string" },
      blur: { type: "number" },
      x: { type: "number" },
      y: { type: "number" },
    },
  },

  // POSITION & MOTION ─────────
  position: {
    type: "command",
    allowProps: true,
    validProps: {
      x: { type: "number" },
      y: { type: "number" },
      z: { type: "number" },
    },
  },
  motion: {
    type: "command",
    allowProps: true,
    validProps: {
      velocityX: { type: "number" },
      velocityY: { type: "number" },
      accelerationX: { type: "number" },
      accelerationY: { type: "number" },
    },
  },
  origin: {
    type: "command",
    allowProps: true,
    validProps: { x: { type: "number" }, y: { type: "number" } },
  },

  // SIZE ─────────
  size: {
    type: "command",
    allowProps: true,
    validProps: { width: { type: "number" }, height: { type: "number" } },
  },
  sizePhysics: {
    type: "command",
    allowProps: true,
    validProps: {
      widthVelocity: { type: "number" },
      widthAcceleration: { type: "number" },
      heightVelocity: { type: "number" },
      heightAcceleration: { type: "number" },
    },
  },

  // ROTATION ─────────
  rotation: {
    type: "command",
    allowProps: true,
    validProps: { value: { type: "number" } },
  },
  rotationPhysics: {
    type: "command",
    allowProps: true,
    validProps: {
      velocity: { type: "number" },
      acceleration: { type: "number" },
    },
  },

  // BORDERS ─────────
  borderTop: {
    type: "command",
    allowProps: true,
    validProps: {
      width: { type: "number" },
      color: { type: "string" },
      type: { type: "string" },
    },
  },
  borderRight: {
    type: "command",
    allowProps: true,
    validProps: {
      width: { type: "number" },
      color: { type: "string" },
      type: { type: "string" },
    },
  },
  borderBottom: {
    type: "command",
    allowProps: true,
    validProps: {
      width: { type: "number" },
      color: { type: "string" },
      type: { type: "string" },
    },
  },
  borderLeft: {
    type: "command",
    allowProps: true,
    validProps: {
      width: { type: "number" },
      color: { type: "string" },
      type: { type: "string" },
    },
  },

  // RADIUS ─────────
  radius: {
    type: "command",
    allowProps: true,
    validProps: {
      tl: { type: "number" },
      tr: { type: "number" },
      bl: { type: "number" },
      br: { type: "number" },
    },
  },

  // LAYOUT ─────────
  overflow: {
    type: "command",
    allowProps: true,
    validProps: { value: { type: "string" } },
  },

  // CONNECTORS ─────────
  connect: {
    type: "command",
    allowProps: true,
    validProps: {
      width: { type: "number" },
      color: { type: "string" },
      z: { type: "number" },
    },
  },

  // CAMERA
  cameraPosition: {
    type: "command",
    allowProps: true,
    allowTargets: false,
    validProps: {
      x: { type: "number" },
      y: { type: "number" },
      z: { type: "number" },
    },
  },
  cameraRotation: {
    type: "command",
    allowProps: true,
    allowTargets: false,
    validProps: {
      value: { type: "number" },
    },
  },
  cameraZoom: {
    type: "command",
    allowProps: true,
    allowTargets: false,
    validProps: {
      value: { type: "number" },
    },
  },
  cameraOrigin: {
    type: "command",
    allowProps: true,
    allowTargets: false,
    validProps: {
      x: { type: "number" },
      y: { type: "number" },
    },
  },
  cameraPositionPhysics: {
    type: "command",
    allowProps: true,
    allowTargets: false,
    validProps: {
      velocityX: { type: "number" },
      velocityY: { type: "number" },
      velocityZ: { type: "number" },
      accelerationX: { type: "number" },
      accelerationY: { type: "number" },
      accelerationZ: { type: "number" },
    },
  },
  cameraRotationPhysics: {
    type: "command",
    allowProps: true,
    allowTargets: false,
    validProps: {
      velocity: { type: "number" },
      acceleration: { type: "number" },
    },
  },
  cameraZoomPhysics: {
    type: "command",
    allowProps: true,
    allowTargets: false,
    validProps: {
      velocity: { type: "number" },
      acceleration: { type: "number" },
    },
  },
  chapter: {
    type: "command",
    allowProps: true,
    allowTargets: false,
    validProps: {
      value: { type: "string" },
    },
  },
};

export default BUILT_IN_COMMANDS;

